import { gql } from "@apollo/client/core";

export const GET_SKU_STOCK_INFO = gql`
  query GetStockLevels($distributorId: ID!, $stockLevelsInput: StockLevelsInput!) {
    getStockLevels(distributorId: $distributorId, stockLevelsInput: $stockLevelsInput) {
      status
      reason
    }
  }
`;
